export default __webpack_public_path__ + "static/media/personal.eca4c6e6.svg";